import { IS_GOOGLE_AUTH } from "@/constants";
import Box from "@mui/material/Box";
import { lazy, Suspense } from "react";
import type { GoogleIdentityButtonProps } from "./GoogleIdentityButton";

// The GIS wrapper (and the Google script it injects) is only fetched when an
// auth page actually renders the button.
const GoogleIdentityButton = lazy(() => import("./GoogleIdentityButton"));

/** GIS "large" button height; reserved while the chunk loads to avoid a jump. */
const BUTTON_HEIGHT = 40;

/**
 * "Sign in / Sign up with Google" followed by an "or" divider.
 * Renders nothing unless the brand is billing-enabled and a client id is set.
 */
export default function GoogleAuthButton(props: GoogleIdentityButtonProps) {
  if (!IS_GOOGLE_AUTH) return null;

  return (
    <Suspense fallback={<Box sx={{ minHeight: BUTTON_HEIGHT }} aria-hidden="true" />}>
      <GoogleIdentityButton {...props} />
    </Suspense>
  );
}
